import React from 'react'

import { Typography } from '@mui/material'
import { PaperPanel } from '../Panel/PaperPanel'

interface GenericMessagePanelProps {
  message: string
}

export const GenericMessagePanel: React.FC<GenericMessagePanelProps> = ({
  message
}) => {
  return (
    <PaperPanel centerText>
      <Typography variant='button'>{message}</Typography>
    </PaperPanel>
  )
}
